/**
 * File filters.js.
 *
 * Filter toggle functionailty
 */

( function() {

    //  Nodelist polyfill
    if ( typeof NodeList.prototype.forEach !== "function" ) {
        NodeList.prototype.forEach = Array.prototype.forEach;
    }
    
    var titles;

    //  Get the filter titles
    titles = document.querySelectorAll( '.alm-filter--title' );
	if ( 'undefined' === typeof titles ) {
		return;
    }

    //  On title click, toggle the container class
    titles.forEach(function(elem) {
        
        elem.onclick = function() {
            
            if ( -1 !== elem.parentElement.className.indexOf( 'active' ) ) {
                elem.parentElement.classList.remove('active');
            } else {
                elem.parentElement.classList.add('active');
            }
        }
    });

} )();
